export enum FeatureToggle {
  GuestManagementEnhancements = 'rt_guest_management_enhancements',
  UserGrantAppeasements = 'rt_guest_management_appeasements',
  // Inverted polarity: when enabled for a retailer, the Custom amount option is hidden in Grant Credits.
  AppeasementDisableCustomAmount = 'rt_appeasement_disable_custom_amount',
}
